import { useTenantStorage } from "multitenancy/tenantStorage";
import { useEffect } from "react";
import { ErrorTile, Loader } from "uikit/components";
import { Heading } from "uikit/components";
import { OrganizationsList } from "./OrganizationList/OrganizationList";
import { useListAvailableTenants } from "hooks/tenants";
import styles from "./OrganizationSelectPage.module.styl";

export default function OrganizationSelectPage() {
    const { clearTenant } = useTenantStorage();

    useEffect(() => {
        void clearTenant();
    }, [clearTenant]);

    const { isError, isLoading, data } = useListAvailableTenants();

    if (isLoading) {
        return <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} />;
    }

    if (isError) {
        return <ErrorTile position={"margin-auto"} />;
    }

    return (
        <div className={styles.container}>
            <Heading size="h1" className={styles.header}>
                Мои организации
            </Heading>

            <OrganizationsList organizations={data.tenantInfos} />
        </div>
    );
}
